import { useQuery } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from 'common/components/PageTitle';
import { CurrentUserDocument } from 'graphql/types';
import { PortfolioTrainingTable } from 'user/components/PortfolioTrainingTable';
import { IUserProfileSectionProps } from 'user/types';

export const PortfolioTrainings = ({ name, id }: IUserProfileSectionProps) => {
    const { data } = useQuery(CurrentUserDocument);
    const [translate] = useTranslation();

    const userId = id || data?.currentUser?.id;

    return (
        <>
            <PageTitle>{`${translate('trainings')} - ${name}`}</PageTitle>

            <PortfolioTrainingTable userId={userId} />
        </>
    );
};
